<template>
  <div>
    <h2>本の検索</h2>
    <b-form-input placeholder="本の名前を検索" type="text" v-model="keyword" @keyup="key" style="width: 50%; margin: auto;"></b-form-input>
    <div style="margin-bottom: 15px;">
      <b-card-group deck>
        <div class="kowai" v-for="(post, index) in posts" :key="index">
          <b-card v-if="keyup" style="background-color: olivedrab;" text-variant="white" header="Book" class="text-center">
            <div class="teach" style="margin-right: 50px; display: inline-flex;">
              <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本の名前</p>
              <h4>{{post.title}}</h4>
            </div>
            <p class="mt-2">オススメ度: {{ post.recommend }}</p>
            <div class="teach" style="margin-right: 50px; display: inline-flex;">
              <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本のタイプ</p>
              <b-card-text style="font-size: 14px;">{{post.type}}</b-card-text>
            </div>
            <div class="teach" style="margin-right: 50px; display: inline-flex;">
              <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">メモ</p>
              <b-card-text>{{post.comment}}</b-card-text>
            </div>
          </b-card>
        </div>
      </b-card-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: '',
      keyup: false
    }
  },
  computed: {
    posts() {
      return this.$store.state.posts.filter(function(item){
        return item.title.indexOf(this.keyword) > -1
      }, this)
    }
  },
  created() {
    this.$store.dispatch('getAll')
  },
  methods: {
    key() {
      if (event.key === "Backspace" || event.key === "Enter") {
        this.keyup = false
      } else {
        this.keyup = true
      }
    }
  }
}
</script>

<style scoped>
.text-white{
  width: 75%;
  margin: auto;
}

.kowai{
  margin-bottom: 20px;
}
</style>